"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var components_1 = require("../../components");
var button_1 = require("../../components/button/button");
var TableStatusDisplayPage = /** @class */ (function (_super) {
    __extends(TableStatusDisplayPage, _super);
    function TableStatusDisplayPage(api, eventId, passKey) {
        var _this = _super.call(this, __1.PageTypes.TableDisplayPage, 'Table Status Display') || this;
        _this.api = api;
        _this.eventId = eventId;
        _this.passKey = passKey;
        _this.loadTables = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.api.getTablesByPasskey(this.eventId, this.passKey)];
                    case 1:
                        _a._tables = _b.sent();
                        this._tableFields = this._tables.map(function (table) {
                            var tableField = new components_1.CheckBoxField(table.tableId.toString(), table.tableName, false, null, true);
                            tableField.observationProvider.observe(_this.tableSelectionChanged, components_1.FieldActions.ValueChanged);
                            return tableField;
                        });
                        this.syncSelectedTableIds();
                        this.observationProvider.notifyObservers(__1.TableStatusDisplayPageActions.Loaded);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.tableSelectionChanged = function () {
            if (_this.isBulkUpdatingTableFields) {
                return;
            }
            _this.syncSelectedTableIds();
            _this.observationProvider.notifyObservers(__1.TableStatusDisplayPageActions.Loaded);
        };
        _this.syncSelectedTableIds = function () {
            _this.form.model.tableIds = _this._tableFields
                .filter(function (tableField) { return tableField.value; })
                .map(function (tableField) { return parseInt(tableField.key, 10); });
        };
        _this.toggleTable = function (tableId) {
            var tableField = _this._tableFields.find(function (field) { return parseInt(field.key, 10) === tableId; });
            if (!tableField) {
                return;
            }
            tableField.setValue(!tableField.value);
        };
        _this.toggleAllTables = function () {
            var shouldSelectAll = _this._tableFields.some(function (tableField) { return !tableField.value; });
            _this.isBulkUpdatingTableFields = true;
            for (var _i = 0, _a = _this._tableFields; _i < _a.length; _i++) {
                var tableField = _a[_i];
                tableField.setValue(shouldSelectAll);
            }
            _this.isBulkUpdatingTableFields = false;
            _this.syncSelectedTableIds();
            _this.observationProvider.notifyObservers(__1.TableStatusDisplayPageActions.Loaded);
        };
        _this.isTableSelected = function (tableId) {
            return _this.form.model.tableIds.indexOf(tableId) !== -1;
        };
        _this.getTable = function (tableId) {
            return _this.tables.find(function (table) { return table.tableId === tableId; });
        };
        _this.loadData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._isLoading = true;
                        this.observationProvider.notifyObservers(__1.TableStatusDisplayPageActions.Loading);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = this;
                        return [4 /*yield*/, this.api.get(__1.EndpointUrls.Public + '/TableDisplay', this.form.model)];
                    case 2:
                        _a._tableDisplayData = _b.sent();
                        this._tableDisplayData.currentDateTimeOffset = __1.DateUtils.CreateDateMaintainTimezone(this._tableDisplayData.currentDateTimeOffset);
                        this.buildGridTimes();
                        if (!this._intervalId) {
                            this._intervalId = setInterval(this.loadData, 60000);
                        }
                        this._settingsVisible = false;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        clearInterval(this._intervalId);
                        this.alert.show({
                            alertType: components_1.AlertType.Error,
                            heading: 'Unable to Load',
                            message: 'TEMS was not able to load table data for this display. Refresh this page to try again.'
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.submitButton.setProcessing(false);
                        this.observationProvider.notifyObservers(__1.TableStatusDisplayPageActions.Loaded);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.buildGridTimes = function () {
            _this._gridTimes = [];
            var currentHour = _this.tableDisplayData.currentDateTimeOffset.getHours();
            var skipFirst = _this.tableDisplayData.currentDateTimeOffset.getMinutes() > 30;
            _this._firstGridDateTime = new Date(_this.tableDisplayData.currentDateTimeOffset.getFullYear(), _this.tableDisplayData.currentDateTimeOffset.getMonth(), _this.tableDisplayData.currentDateTimeOffset.getDate(), currentHour, skipFirst ? 30 : 0);
            for (var hour = currentHour; hour < 24; hour++) {
                var prefix = hour < 10 ? '0' : '';
                if (!skipFirst) {
                    _this._gridTimes.push(prefix + hour + '00');
                }
                skipFirst = false;
                _this._gridTimes.push(prefix + hour + '30');
            }
        };
        _this.observationProvider = new __1.ObservationProvider();
        _this._settingsVisible = true;
        _this._form = new __1.Form([
            new components_1.CheckBoxField('displayMeetingList', 'Display Meeting List'),
            new components_1.CheckBoxField('displayMeetingGrid', 'Display Meeting Grid'),
            new components_1.CheckBoxField('displayMeetingName', 'Meeting Name'),
            new components_1.CheckBoxField('displayMeetingNumber', 'Meeting Number'),
            new components_1.CheckBoxField('displayMeetingTime', 'Meeting Time'),
            new components_1.CheckBoxField('displayMeetingPoc', 'Meeting POC'),
            new components_1.CheckBoxField('displaySeatCount', 'Seat Count'),
            new components_1.CheckBoxField('displayAttendeesSeated', 'Attendees Seated')
        ], {
            eventId: eventId,
            passKey: passKey,
            displayMeetingGrid: true,
            displayMeetingList: false,
            displayMeetingName: false,
            displayMeetingNumber: true,
            displayMeetingTime: false,
            displayMeetingPoc: false,
            displaySeatCount: true,
            displayAttendeesSeated: true,
            tableIds: []
        });
        _this.form.observationProvider.observe(_this.loadData, components_1.FormActions.FormSubmitted);
        _this.submitButton = new button_1.default({
            text: 'Show Display',
            onClick: _this.form.submit,
            processingText: 'Loading...'
        });
        _this._tables = [];
        _this._tableFields = [];
        _this._gridTimes = [];
        _this.isBulkUpdatingTableFields = false;
        _this.loadTables();
        return _this;
    }
    Object.defineProperty(TableStatusDisplayPage.prototype, "firstGridDateTime", {
        get: function () {
            return this._firstGridDateTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableStatusDisplayPage.prototype, "form", {
        get: function () {
            return this._form;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableStatusDisplayPage.prototype, "settingsVisible", {
        get: function () {
            return this._settingsVisible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableStatusDisplayPage.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableStatusDisplayPage.prototype, "tableDisplayData", {
        get: function () {
            return this._tableDisplayData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableStatusDisplayPage.prototype, "gridTimes", {
        get: function () {
            return this._gridTimes;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableStatusDisplayPage.prototype, "tables", {
        get: function () {
            return this._tables;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableStatusDisplayPage.prototype, "tableFields", {
        get: function () {
            return this._tableFields;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableStatusDisplayPage.prototype, "selectedTables", {
        get: function () {
            var _this = this;
            return this.tables.filter(function (table) { return _this.isTableSelected(table.tableId); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableStatusDisplayPage.prototype, "selectedMeetings", {
        get: function () {
            var _this = this;
            if (!this.tableDisplayData) {
                return [];
            }
            return this.tableDisplayData.meetings.filter(function (meeting) { return _this.isTableSelected(meeting.tableId); });
        },
        enumerable: false,
        configurable: true
    });
    return TableStatusDisplayPage;
}(__1.BasePage));
exports.default = TableStatusDisplayPage;
